module.exports = __webpack_public_path__ + "img/binding_armhole_width.a139c9a1.png";